import { useEffect, useRef, useState } from "react";
import { Play, Pause, SkipForward, SkipBack, Music } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Lecteur très simple : une grande touche lecture / pause, chanson suivante ou précédente.
export default function SimpleMusicPlayer({ tracks }) {
  const [i, setI] = useState(0);
  const [playing, setPlaying] = useState(false);
  const audio = useRef(null);
  const t = tracks[i];
  useEffect(() => {
    if (!audio.current) return;
    audio.current.load();
    if (playing) audio.current.play().catch(() => setPlaying(false));
  }, [i]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => () => audio.current?.pause(), []);
  const toggle = () => {
    if (playing) { audio.current.pause(); setPlaying(false); }
    else { audio.current.play().then(() => setPlaying(true)).catch(() => {}); }
  };
  const go = (d) => setI((v) => (v + d + tracks.length) % tracks.length);
  if (!t) return null;
  return (
    <div className="w-full max-w-2xl soft-in" data-testid="patient-music">
      <div className="rounded-[2rem] bg-white border-4 border-rose-100 p-8 text-center mb-6">
        <Music className="w-12 h-12 text-rose-400 mx-auto mb-3" />
        <p className="font-patient font-black text-3xl text-gray-800" data-testid="patient-music-title">{t.title}</p>
        {t.artist && <p className="font-patient text-xl text-gray-500 mt-1">{t.artist}</p>}
        <audio ref={audio} src={`${BACKEND}${t.audio_url}`} onEnded={() => (tracks.length > 1 ? go(1) : setPlaying(false))} />
        <div className="flex items-center justify-center gap-6 mt-8">
          {tracks.length > 1 && (
            <button onClick={() => go(-1)} aria-label="Chanson précédente" data-testid="patient-music-prev"
              className="w-20 h-20 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"><SkipBack className="w-9 h-9 text-gray-700" /></button>
          )}
          <button onClick={toggle} aria-label={playing ? "Pause" : "Écouter"} data-testid="patient-music-toggle"
            className="w-32 h-32 rounded-full bg-rose-500 hover:bg-rose-600 shadow-lg flex items-center justify-center transition-colors">
            {playing ? <Pause className="w-16 h-16 text-white" /> : <Play className="w-16 h-16 text-white ml-2" />}
          </button>
          {tracks.length > 1 && (
            <button onClick={() => go(1)} aria-label="Chanson suivante" data-testid="patient-music-next"
              className="w-20 h-20 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"><SkipForward className="w-9 h-9 text-gray-700" /></button>
          )}
        </div>
      </div>
      <div className="space-y-3">
        {tracks.map((x, k) => (
          <button key={x.id} onClick={() => { if (k === i) { if (!playing) toggle(); } else { setI(k); setPlaying(true); } }} data-testid={`patient-music-track-${x.id}`}
            className={`w-full text-left rounded-3xl border-4 px-6 py-4 font-patient text-xl transition-colors ${k === i ? "bg-rose-50 border-rose-300 text-rose-900" : "bg-white border-gray-100 text-gray-800 hover:border-rose-200"}`}>
            {x.title}{x.artist && <span className="text-gray-500"> · {x.artist}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
